// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"93654e10","213":"f0aef740","239":"8bc3bd4a","453":"56dde0d0","612":"bb6dee5f","638":"c7648d38","732":"a272cd5f","807":"0b331eb7","909":"4d4856a6"}[chunkId] + ".chunk.js";
};